import type { SVGProps } from "react";
import * as React from "react";

const SvgGitPullRequest = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 5a1 1 0 1 0 0 2zm3 1V5zM5 21a1 1 0 1 0 2 0zm15-3a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4zm-2 2a2 2 0 0 1-2-2h-2a4 4 0 0 0 4 4zm-2-2a2 2 0 0 1 2-2v-2a4 4 0 0 0-4 4zm2-2a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4zM8 6a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4zM6 8a2 2 0 0 1-2-2H2a4 4 0 0 0 4 4zM4 6a2 2 0 0 1 2-2V2a4 4 0 0 0-4 4zm2-2a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4zm7 3h3V5h-3zm3 0a1 1 0 0 1 .707.293l1.414-1.414A3 3 0 0 0 16 5zm.707.293A1 1 0 0 1 17 8h2a3 3 0 0 0-.879-2.121zM17 8v7h2V8zM5 9v12h2V9z"
    />
  </svg>
);
export default SvgGitPullRequest;
